/* eslint-disable react/no-string-refs */

import PropTypes from 'prop-types'
import React, { Component } from 'react'
import $ from 'jquery'
import classNames from 'classnames'
import Hub from 'base/hub'
import Event from 'base/event'
import { Plus, Minus } from '@everlane/icon'

class ExpandableContent extends Component {
  static propTypes = {
    openByDefault: PropTypes.bool,
    title: PropTypes.string.isRequired,
    className: PropTypes.string,
    trayType: PropTypes.string.isRequired,
    trackEvent: PropTypes.bool,
    onExpand: PropTypes.func,
    onClose: PropTypes.func,
    children: PropTypes.element,
    iconColor: PropTypes.string,
  }

  static defaultProps = {
    trackEvent: true,
    iconColor: '#808264',
  }

  state = {
    isOpen: this.props.openByDefault,
    toggledByUser: false,
  }

  componentDidUpdate(prevProps, prevState) {
    // These conditions are in place to account for the chance that
    // `openByDefault` changes without the component remounting
    if (
      !prevProps.openByDefault &&
      this.props.openByDefault &&
      !prevState.toggledByUser &&
      !this.state.toggledByUser &&
      !this.state.isOpen
    ) {
      this.setState({ isOpen: true })
    }

    if (
      prevProps.openByDefault &&
      !this.props.openByDefault &&
      !prevState.toggledByUser &&
      !this.state.toggledByUser &&
      this.state.isOpen
    ) {
      this.setState({ isOpen: false })
    }
  }

  handleToggleExpand = () => {
    if (this.state.isOpen) {
      if (this.props.trackEvent) {
        Hub.pub(Event.Product.TRAY_CLOSE, { tray_type: this.props.trayType })
      }

      const container = $(this.refs.container)
      const contents = container.children()

      if (contents) {
        contents.velocity({ opacity: 0, duration: 300 })
      }

      container.velocity('slideUp', {
        duration: 300,
        easing: 'easeOutQuart',
        complete: () => {
          this.setState({ isOpen: false, toggledByUser: true })

          if (this.props.onClose) {
            this.props.onClose()
          }
        },
      })
    } else {
      if (this.props.trackEvent) {
        Hub.pub(Event.Product.TRAY_OPEN, { tray_type: this.props.trayType })
      }

      this.setState({ isOpen: true, toggledByUser: true }, () => {
        const container = $(this.refs.container)
        const contents = container.children()

        container.hide()
        contents.css('opacity', 0)

        if (container) {
          container.velocity('slideDown', {
            duration: 300,
            easing: 'easeOutQuart',
            complete: () => {
              if (this.props.onExpand) {
                this.props.onExpand(this.props.title)
              }
            },
          })
        }
        if (contents) {
          contents.velocity({ opacity: 1, duration: 300 })
        }
      })
    }
  }

  renderContentContainer() {
    return (
      <div
        className="expandable-content__container"
        data-cy="expandable-content__container"
        ref="container"
      >
        {this.props.children}
      </div>
    )
  }

  render() {
    const isOpen = this.state.toggledByUser ? this.state.isOpen : this.props.openByDefault
    const wrapperClassNames = classNames('expandable-content', this.props.className)
    const titleClassNames = classNames('expandable-content__title', {
      'expandable-content__title--open': isOpen,
    })

    return (
      <section className={wrapperClassNames}>
        <h4 className={titleClassNames} onClick={this.handleToggleExpand}>
          {this.props.title}
          {isOpen ? (
            <Minus className="expandable-content__title-icon" stroke={this.props.iconColor} />
          ) : (
            <Plus className="expandable-content__title-icon" stroke={this.props.iconColor} />
          )}
        </h4>
        <div hidden={!isOpen}>{this.renderContentContainer()}</div>
      </section>
    )
  }
}

export default ExpandableContent
